import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { orderEventActivity, shapeEvent } from './helpers';
import { ACTIVITY_EMPTY, EventActivityStatus } from './constants';
import styles from './playersList.scss';

// Event Activity cell (desktop cell + mobile expanded section). Up to two events, ordered in-progress →
// upcoming → completed. Each row is a status label (`Upcoming: {date}` / `In Progress` / `Completed` —
// the date shows only for Upcoming) over the event-title link. The link routes by feed source (Tms → the
// TMS event profile, Leagues → the Leagues event page) and stays same-tab like the app's other event
// links. No activity of this kind → `—`.
const EventActivityCell = ({ events, 'data-testid': dataTestId }) => {
    const shaped = orderEventActivity(events).map(shapeEvent);

    if (shaped.length === 0) {
        return (
            <div className={`${styles.activityCell} ${styles.activityCellEmpty}`} data-testid={dataTestId || undefined}>
                <span className={styles.activityEmpty} data-testid={dataTestId && `${dataTestId}.empty`}>
                    {ACTIVITY_EMPTY}
                </span>
            </div>
        );
    }

    return (
        <div className={styles.activityCell} data-testid={dataTestId || undefined}>
            {shaped.map((event, index) => {
                const rowTestId = dataTestId && `${dataTestId}.event-${index}`;
                const statusLabel = event.status === EventActivityStatus.UPCOMING && event.date
                    ? `${event.label}: ${event.date}`
                    : event.label;
                return (
                    <div key={event.eventId ?? `${event.status}-${event.title}`} className={styles.eventRow}>
                        {statusLabel && (
                            <span className={styles.eventStatus} data-testid={rowTestId && `${rowTestId}.status`}>
                                {statusLabel}
                            </span>
                        )}
                        {event.url ? (
                            <Link
                                className={styles.eventLink}
                                to={event.url}
                                data-testid={rowTestId || undefined}
                            >
                                {event.title}
                            </Link>
                        ) : (
                            <span className={styles.eventTitle} data-testid={rowTestId || undefined}>
                                {event.title}
                            </span>
                        )}
                    </div>
                );
            })}
        </div>
    );
};

EventActivityCell.propTypes = {
    events: PropTypes.arrayOf(PropTypes.instanceOf(Object)),
    'data-testid': PropTypes.string,
};

EventActivityCell.defaultProps = {
    events: [],
    'data-testid': null,
};

export default EventActivityCell;
